import { permissionHelper } from "@/core/utils";
import { ROUTE_NAME } from "@/core/constants";

export const accessRightsService = {
  checkUserAccessRights,
  authorizedNavigationList,
};

export const navigationList = [
  {
    path: "/home",
    name: "home",
    routeName: ROUTE_NAME.HOME,
    icon: "nc-tv-2",
    authPermissionModule: "",
  },
  {
    path: "/role-permission",
    name: "rolePermission",
    routeName: ROUTE_NAME.ROLE_PERMISSION,
    icon: "nc-lock-circle-open",
    authPermissionModule: "permissions_view",
  },
  {
    path: "/devOps",
    name: "devOps",
    routeName: ROUTE_NAME.DEVOPS,
    icon: "nc-settings-tool-66",
    authPermissionModule: "",
    children: [
      {
        path: "create-account",
        name: "createAccount",
        routeName: ROUTE_NAME.DEVOPS_CREATE_ACCOUNT,
        icon: "nc-chart-pie-35",
        authPermissionModule: "devops_create_account",
      },
      {
        path: "account-logger",
        name: "accountLogger",
        routeName: ROUTE_NAME.DEVOPS_ACCOUNT_LOGGER,
        icon: "nc-circle-09",
        authPermissionModule: "devops_account_logger",
      },
    ],
  },
];

function checkUserAccessRights(moduleName, action) {
  let showAction = false;
  let permissions = permissionHelper.getUserPermissions();
  if (moduleName != "" && action != null && permissions != null) {
    permissions.forEach((x) => {
      if (x.name == moduleName) {
        action.forEach((y) => {
          if (x.actions.find((z) => z.value == y)) {
            showAction = true;
          }
        });
      }
    });
  }
  return showAction;
}

function authorizedNavigationList() {
  let permissions = permissionHelper.getUserPermissions().map((x) => {
    return x.name;
  });
  let newlist = [];
  navigationList.forEach((x) => {
    if (x.name == "home") newlist.push(x);

    x.authorizeModules.forEach((y) => {
      if (permissions.includes(y)) {
        if (newlist.findIndex((z) => z.name == x.name) == -1) {
          newlist.push(x);
        }
      }
    });
  });

  newlist.forEach((x) => {
    let newChildren = [];
    x.children.forEach((y) => {
      y.authorizeModules.forEach((z) => {
        if (permissions.includes(z)) {
          newChildren.push(y);
        }
      });
    });
    x.children = newChildren;
  });

  return newlist;
}
